import config from '../../config';
import APIService from './APIService';

export default class AuditTrailService extends APIService {
  /**
   * To get the sources from where logs can come
   */
  static getSources() {
    return this.get(
      `${config.baseUrlForAuditLogService}/audit/logs/search/sources`
    );
  }
  /**
   * To get the categories of the logs
   */
  static getEventCategories() {
    return this.get(
      `${config.baseUrlForAuditLogService}/audit/logs/search/categories`
    );
  }
  /**
   * To search the logs of specific org
   * postBody is for search params from advance search
   * @param {string} orgId
   * @param {Object} postBody
   */
  static searchLogs(orgId, postBody) {
    return this.post(
      `${config.baseUrlForAuditLogService}/audit/logs/search/${orgId}`,
      postBody
    );
  }
  /**
   * To get details of a specific log
   *
   * @param {string} orgId
   * @param {string} logId
   */
  static getLogDetails(orgId, logId) {
    return this.get(
      `${config.baseUrlForAuditLogService}/audit/logs/search/${orgId}?logId=${logId}`
    );
  }
}
